import { useQuery } from "@tanstack/react-query";
import { API_OPEN_STREET } from "@/utils/api/config";

const fetchGeolocation = async (lat: number, lng: number) => {
	const response = await fetch(
		`${API_OPEN_STREET}/reverse?format=json&lat=${lat}&lon=${lng}`
	);
	if (!response.ok) {
		throw new Error("Network response was not ok");
	}
	const data = await response.json();
	return data;
};

const useGeolocation = (lat: number, lng: number) => {
	return useQuery({
		queryKey: ["get-location", lat, lng],
		queryFn: () => fetchGeolocation(lat, lng),
		enabled: !!lat && !!lng,
	});
};

export default useGeolocation;
